export function defaultCountryCode(el, code) {
  if (el.val() === '') {
    $(el).val(code).triggerMultiple('chosen:updated change').next().addClass('filled');
  }
}


// WEBPACK FOOTER //
// ./app/webpacker/src/js/modules/country_code.js